
export const SET_LOGIN_HISTORY_SEARCH_QUERY = "SET_LOGIN_HISTORY_SEARCH_QUERY"

export const RESET_LOGIN_HISTORY_SEARCH_QUERY =
  "RESET_LOGIN_HISTORY_SEARCH_QUERY"

export const GET_LOGIN_HISTORY = "GET_RLOGIN_HISTORY"
export const GET_LOGIN_HISTORY_SUCCESS = "GET_LOGIN_HISTORY_SUCCESS"
export const GET_LOGIN_HISTORY_FAIL = "GET_LOGIN_HISTORY_FAIL"
